import React from "react";
import FacultyDiscussionBoardSection from "./Board";


export default function FacultyCurrentDashboardItem({ CourseClasses = [], slug, userProfile }) {

  const preparationWeekClass = (CourseClasses || [])
    .filter((courseClass) => {

      return courseClass.classType === "preparation";
    });

  const currentDiscussionBoardKey = "Preparation Week and Orientation Session"

  return (
    <div
      style={{
        padding: "1rem 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <div style={{ width: "100%", marginTop: "1rem" }}>
        {preparationWeekClass.map((item) => {
          // const hasNotification = discussionBoardNotifications.some(
          //   (notif) => +notif.meta.certificateClassId === item.id,
          // );

          return (
            <>
              {String(item.title).startsWith(currentDiscussionBoardKey) && (
                <div
                  style={{
                    border: ".5px solid black",
                    borderRadius: "16px",
                    padding: "1rem",
                    width: "100%",
                  }}
                >
                  <FacultyDiscussionBoardSection
                    slug={slug}
                    userProfile={userProfile}
                    user={item?.User}
                    certificateClassId={item.id}
                    hasNotification={false}
                    // hasNotification={hasNotification}
                  />
                </div>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
}